<style lang="scss">
#agenda-show-appointment {
  .mb4px {
    margin-bottom: 4px !important;
  }

  .status-check {
    flex-grow: 1;
  }

  .status-check+.status-check {
    margin-left: 23px;
  }

  .whatsapp {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    color: var(--theme-grey);
    height: 53.6px;
    text-decoration: none;

    &:hover {
      color: var(--theme-color);
    }

    i {
      font-size: 32px;
    }
  }

  .color-container {
    position: absolute;
    bottom: 30px;
    left: 0;
  }

  .modal-dialog {
    max-width: 960px !important;
  }
}
</style>
<template>
  <div>
    <customer-new v-if="!locked" @submit="onCustomerCreated" ref="customerNew"></customer-new>
    <customer-show-document @add="onDocumentAdded" @edit="onDocumentEdited" ref="showdocument"
      :customer="selected_customer" :embed="true"></customer-show-document>
    <appointment-history ref="apphistory" :appointment="this.appointment"></appointment-history>

    <b-modal ref="modal" :title="dialog_title" hide-footer id="agenda-show-appointment">
      <!-- Customer Search Selector -->
      <div class="form-group row">
        <div v-if="is_edit" class="col-sm-12 text-center mb-2">
          <div class="d-flex align-items-center justify-content-between text-muted" style="font-size: 0.8rem">
            <div><b>Creada:</b> {{ created_at }}</div>
            <div><b>Usuario:</b> {{ user_name }}</div>
            <div><b>Ult modificación:</b> {{ updated_at }}</div>
            <div>
              <button @click="showHistory" class="btn btn-wabident-round small">
                Historial
              </button>
            </div>
          </div>
        </div>

        <div v-if="!selected_customer" class="col-sm-12">
          <div class="form-check form-check-inline mb-2">
            <input v-model="is_note" class="form-check-input" type="checkbox" id="app_new_note" value="true" />
            <label class="form-check-label" for="app_new_note">Activar Nota ( Sin paciente ni tratamiento )
            </label>
          </div>
        </div>

        <div v-show="!is_note" class="col-sm-12">
          <customer-search ref="search" :locked="locked || agenda_restricted" :clinics="clinics"
            @customerSelected="customerSelected" @customerDeselected="customerDeselected"></customer-search>
        </div>

        <div v-if="selected_customer" class="col-sm-12">
          <a :href="customer_edit_link" target="_blank" class="btn-link">Ver ficha de paciente</a>
        </div>
        <div v-else-if="!is_note && !locked" class="col-sm-12">
          <span role="button" class="btn-link" @click="onNewCustomer">Añadir un nuevo paciente</span>
        </div>
      </div>

      <div class="form-group row" v-show="!treatments_only">
        <div v-if="!is_note && is_aesthetic && is_edit" class="col">
          <select id="app_changed_reason" v-model="changed_reason" class="custom-select" required>
            <option :value="null">Elige una opción</option>
            <option value="clinic">Clínica</option>
            <option value="customer">Paciente</option>
          </select>
          <label for="app_changed_reason" class="wabident-info">Motivo del cambio (obligatorio)</label>
        </div>

        <div v-if="!is_note && is_aesthetic" class="col">
          <select id="app_select_origin" v-model="app_origin" class="custom-select" required>
            <option :value="null">Elige una opción</option>
            <option value="mobile">Whatsapp</option>
            <option value="phone">Teléfono</option>
            <option value="email">Email</option>
            <option value="door">Puerta</option>
          </select>
          <label for="app_select_origin" class="wabident-info">¿Cómo se tomó la cita? (obligatorio)</label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col" v-if="can_edit_user">
          <select id="app_select_user" v-model="user_id" class="custom-select">
            <option :value="null">Selecciona Usuari@</option>
            <option v-for="(user, i) in active_users" :key="i" :value="user.id" :disabled="user.is_active == 0">
              {{ user.name }}
            </option>
          </select>
          <label for="app_select_user" class="wabident-info">¿Quien toma la cita?</label>
        </div>

        <div class="col" v-if="can_edit_user && this.is_edit && this.is_date_changed">
          <select id="app_select_mod_user" v-model="mod_user_id" class="custom-select">
            <option :value="null">Selecciona Usuari@</option>
            <option v-for="(user, i) in active_users" :key="i" :value="user.id" :disabled="user.is_active == 0">
              {{ user.name }}
            </option>
          </select>
          <label for="app_select_mod_user" class="wabident-info">¿Quien modifica la cita?</label>
        </div>

        <div class="col" v-if="!is_core || !is_note">
          <select id="app_select_doctor" v-model="doctor_id" class="custom-select"
            :disabled="doctor_locked || agenda_restricted || treatments_only">
            <option :value="null">Selecciona Doctor(a)</option>
            <option v-for="(doctor, i) in doctors" :key="i" :value="doctor.doctor.id" :disabled="doctor.is_active == 0">
              {{ doctor.name }}
            </option>
          </select>
          <label for="app_select_doctor" class="wabident-info">Doctor(a)</label>
        </div>
      </div>

      <!-- Is First Appointment -->
      <div v-show="!is_note && selected_customer" class="row form-group">
        <div class="col-md-3">
          <div class="form-check form-check-inline mb-2">
            <input v-model="is_first" class="form-check-input" type="checkbox" id="app_is_first" value="true"
              :disabled="agenda_restricted || treatments_only" />
            <label class="form-check-label" for="app_is_first">¿Es primera cita?
            </label>
          </div>
        </div>
        <div class="col" v-if="is_first">
          <select id="app_select_category" v-model="product_category_id" class="custom-select"
            :disabled="agenda_restricted">
            <option :value="null">Sin unidad</option>
            <option v-for="(category, id) in categories" :key="id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
          <label for="app_select_category" class="wabident-info">Unidad</label>
        </div>
      </div>

      <div v-if="can_add_new_treatment" class="form-group row">
        <div class="col-sm-12">
          <h6>Añadir tratamientos/productos nuevos</h6>
        </div>
        <div class="col">
          <product-search v-model="selected_product"></product-search>
          <label for="" class="wabident-info">Los tratamientos se añadirán al último plan creado o se creará uno
            nuevo</label>
        </div>
        <div class="col-sm-2">
          <button style="height: 50.5px" class="btn btn-wabident-round" :disabled="!selected_product && !is_loading"
            @click="addProductToAppointment">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <g clip-path="url(#clip0_207_1621)">
                <path
                  d="M10.4508 5.05076L6.94923 5.05076L6.94923 1.54919C6.94923 1.29745 6.84922 1.05601 6.67121 0.877996C6.49319 0.699983 6.25176 0.599976 6.00001 0.599976C5.74826 0.599976 5.50682 0.699983 5.32881 0.877996C5.15079 1.05601 5.05079 1.29745 5.05079 1.54919L5.05079 5.05076L1.54922 5.05076C1.29748 5.05076 1.05604 5.15076 0.878025 5.32878C0.700012 5.50679 0.600006 5.74823 0.600006 5.99998C0.600006 6.25172 0.700012 6.49316 0.878025 6.67117C1.05604 6.84919 1.29748 6.94919 1.54922 6.94919L5.05079 6.94919L5.05079 10.4508C5.05079 10.7025 5.15079 10.9439 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.9439 6.94922 10.7025 6.94922 10.4508L6.94922 6.94919L10.4508 6.94919C10.7025 6.94919 10.944 6.84919 11.122 6.67117C11.3 6.49316 11.4 6.25172 11.4 5.99998C11.4 5.74823 11.3 5.50679 11.122 5.32878C10.944 5.15076 10.7025 5.05076 10.4508 5.05076Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_207_1621">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Añadir
          </button>
        </div>
      </div>

      <!-- Customer Treatment Selector -->
      <div v-show="!is_first && !is_note && selected_customer && customer_has_treatments
        " class="form-group row" :class="{ mb4px: selected_treatment_ids }">
        <div class="col-sm-12">
          <h6>Asignar tratamientos</h6>
        </div>
        <div class="col">
          <select v-model="selected_treatment" class="custom-select wabident-small" :disabled="agenda_restricted">
            <option value="0">
              Selecciona tratamientos (Obligatorio al menos 1)
            </option>
            <option v-for="treatment in customer_treatments" :key="treatment.id" :value="treatment.id">
              {{ getTreatmentName(treatment) }}
            </option>
          </select>
        </div>
      </div>

      <!-- Treatment List -->
      <div v-show="selected_treatment_ids" class="form-group row no-gutters mb-3">

        <div class="col-sm-12 mt-2">
          <h6>Tratamiento asignados</h6>
        </div>

        <div class="col-sm-12">
          <a @click="removeTreatment(treatment.id)" role="button"
            class="btn wabident-badge wabident-badge__clear wabident-badge__ellipsis"
            v-for="treatment in selected_customer_treatments" style="margin: 4px" :key="treatment.id">{{
              getTreatmentName(treatment, true) }}</a>
        </div>

        <div v-if="treatment_duration" class="col-sm-12">
          <small>Duración aprox. de los tratamientos:
            <b>{{ treatment_duration }} minutos</b>
          </small>
        </div>
      </div>

      <!-- Date/Time Selector -->
      <div class="form-group row">
        <div class="col-md-12">
          <h6>FECHA, HORA Y LUGAR</h6>
        </div>
        <div class="col-sm-5">
          <input v-model="selected_date" type="date" class="form-control" id="app_new_date"
            :disabled="agenda_restricted || treatments_only" />
          <label for="app_new_date" class="wabident-info">Día</label>
        </div>
        <div v-show="!is_vacation" class="col-sm-2">
          <select v-model="selected_time_start" id="app_time_start" class="form-control custom-select"
            :disabled="agenda_restricted || treatments_only">
            <template v-if="clinic">
              <optgroup label="Mañana">
                <option v-for="(slot, i) in day_slots.morning.start" :key="i" :value="slot">
                  {{ slot }}
                </option>
              </optgroup>
              <optgroup label="Tarde">
                <option v-for="(slot, i) in day_slots.afternoon.start" :key="i" :value="slot">
                  {{ slot }}
                </option>
              </optgroup>
            </template>
          </select>
          <label for="app_new_time_start" class="wabident-info">Hora de Inicio</label>
        </div>
        <div v-show="!is_vacation" class="col-sm-2">
          <select v-model="selected_time_end" id="app_time_end" class="form-control custom-select"
            :disabled="agenda_restricted || treatments_only">
            <template v-if="clinic">
              <optgroup label="Mañana">
                <option v-for="(slot, i) in day_slots.morning.end" :key="i" :value="slot">
                  {{ slot }}
                </option>
              </optgroup>
              <optgroup label="Tarde">
                <option v-for="(slot, i) in day_slots.afternoon.end" :key="i" :value="slot">
                  {{ slot }}
                </option>
              </optgroup>
            </template>
          </select>
          <label for="app_new_time_end" class="wabident-info">Hora de Fin</label>
        </div>
        <div v-show="!is_vacation" class="col-sm-3">
          <select v-model.number="selected_box" id="app_new_box" class="form-control custom-select"
            :disabled="agenda_restricted || treatments_only">
            <template v-if="clinic">
              <option :value="0">Elige un Box (Opcional)</option>
              <option v-for="box in clinic.boxes" :key="box.id" :value="box.id">
                {{ box.name }}
              </option>
            </template>
          </select>
          <label for="app_new_box" class="wabident-info">Box</label>
        </div>
      </div>
      <!-- Notes -->
      <div class="form-group row">
        <div class="col-sm-12">
          <textarea v-model.lazy="app_notes" class="form-control" id="app_new_notes" rows="4"></textarea>
          <label for="app_new_notes" class="wabident-info">Notas privadas</label>
        </div>
      </div>
      <div class="form-group row" v-if="public_notes_enabled">
        <div class="col-sm-12">
          <textarea v-model.lazy="app_public_notes" class="form-control" id="app_new_public_notes" rows="4"></textarea>
          <label for="app_new_public_notes" class="wabident-info"><strong>Notas para el paciente. Se enviarán a la
              APP</strong></label>
        </div>
      </div>

      <div v-if="treatments_only || next_app_data['date_from']" class="form-group row my-3">
        <div class="col-md-12">
          <h6><strong>PRÓXIMA CITA</strong></h6>
        </div>

        <div class="col-md-6">
          <input v-model="next_app_data['date_from']" type="datetime-local" class="form-control" id="next_new_date"
            :disabled="!treatments_only" />
          <label for="next_new_date" class="wabident-info">Fecha y hora aproximada</label>
        </div>

        <div class="col-md-6">
          <select id="next_select_doctor" v-model="next_app_data['doctor_id']" class="custom-select"
            :disabled="!treatments_only">
            <option :value="null">Selecciona Doctor(a)</option>
            <option v-for="(doctor, i) in doctors" :key="i" :value="doctor.doctor.id" :disabled="doctor.is_active == 0">
              {{ doctor.name }}
            </option>
          </select>
          <label for="next_select_doctor" class="wabident-info">Doctor(a)</label>
        </div>

        <div class="col-md-12">
          <textarea v-model.lazy="next_app_data['notes']" class="form-control" id="app_next_notes" rows="2"
            :disabled="!treatments_only"></textarea>
          <label for="app_next_notes" class="wabident-info">Notas</label>
        </div>
      </div>

      <!-- Documents -->
      <div v-if="is_core && selected_customer" class="my-2">
        <customer-document-list :customer="selected_customer" :documents="documents" @add="addDocument"
          @edit="editDocument">
        </customer-document-list>
      </div>

      <!-- Checks -->
      <div v-show="!treatments_only" class="form-group row">
        <div v-if="enable_custom_checks" class="col-sm-12">
          <div class="form-check form-check-inline" v-for="(name, slug) in custom_check_list" :key="slug">
            <input v-model="custom_checks[slug]" class="form-check-input" type="checkbox" :id="'custom_check_' + slug"
              value="true" />
            <label class="form-check-label" :for="'custom_check_' + slug">{{
              name
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="is_custom_color" class="form-check-input" type="checkbox" id="app_new_color" value="true" />
            <label class="form-check-label" for="app_new_color">Color Personalizado</label>
            <div v-if="is_custom_color" class="color-container">
              <wabident-color-picker v-model="colors"></wabident-color-picker>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-12">
          <div class="form-check form-check-inline">
            <input v-model="is_urgent" class="form-check-input" type="checkbox" id="app_new_urgent" value="true"
              :disabled="agenda_restricted" />
            <label class="form-check-label" for="app_new_urgent">Urgencia</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="is_insurance" class="form-check-input" type="checkbox" id="app_new_insurance" value="true"
              :disabled="agenda_restricted" />
            <label class="form-check-label" for="app_new_insurance">
              <span v-if="is_aesthetic">Coolsculpting</span>
              <span v-else>Seguro</span>
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="is_revision" class="form-check-input" type="checkbox" id="app_new_revision" value="true"
              :disabled="agenda_restricted" />
            <label class="form-check-label" for="app_new_revision">
              <span v-if="is_aesthetic">Nota</span>
              <span v-else>Revisión</span>
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="is_marked" class="form-check-input" type="checkbox" id="app_new_marked" value="true"
              :disabled="agenda_restricted" />
            <label class="form-check-label" for="app_new_marked">
              <span v-if="is_aesthetic">Láser/Qx</span>
              <span v-else>Trabajo en clínica</span>
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="is_custom_color" class="form-check-input" type="checkbox" id="app_new_color" value="true"
              :disabled="agenda_restricted" />
            <label class="form-check-label" for="app_new_color">Color Personalizado</label>
            <div v-if="is_custom_color" class="color-container">
              <wabident-color-picker v-model="colors"></wabident-color-picker>
            </div>
          </div>
        </div>
      </div>
      <!-- END Checks -->

      <!-- Buttons -->
      <div v-show="is_edit && !is_note && !treatments_only" class="form-group row">
        <div v-if="is_edit" class="col-sm-12 text-center mb-2">
          <div class="d-flex align-items-center justify-content-between text-muted" style="font-size: 0.8rem">
            <div v-if="arrival_time"><b>Llegó:</b> {{ arrival_time }}</div>
            <div v-if="attended_time"><b>Atendid@:</b> {{ attended_time }}</div>
            <div v-if="leaving_time"><b>Tratad@:</b> {{ leaving_time }}</div>
            <div v-if="gone_time"><b>Se fue:</b> {{ gone_time }}</div>
          </div>
        </div>

        <div class="col d-flex flex-row justify-content-center status-buttons">
          <button v-if="is_core" type="button" @click="setAppStatus('confirmed')"
            class="btn btn-wabident-status confirmed status-check" :class="{
              unmarked: !(
                app_status == 'arrived' ||
                app_status == 'confirmed' ||
                app_status == 'attended' ||
                app_status == 'treated' ||
                app_status == 'leaving' ||
                app_status == 'gone'
              ),
            }">
            Confirmada
          </button>

          <button type="button" @click="setAppStatus('arrived')" class="btn btn-wabident-status presented status-check"
            :class="{
              unmarked: !(
                app_status == 'arrived' ||
                app_status == 'attended' ||
                app_status == 'treated' ||
                app_status == 'leaving' ||
                app_status == 'gone'
              ),
            }">
            Se presentó
          </button>

          <button type="button" @click="setAppStatus('attended')" class="btn btn-wabident-status attended status-check"
            :class="{
              unmarked: !(
                app_status == 'attended' ||
                app_status == 'treated' ||
                app_status == 'gone' ||
                app_status == 'leaving'
              ),
            }">
            Atendid@
          </button>

          <button v-if="clinic_type == 'aesthetic' || is_core" type="button" @click="setAppStatus('treated')"
            class="btn btn-wabident-status treated status-check" :class="{
              unmarked: !(app_status == 'treated' || app_status == 'gone'),
            }">
            Tratad@
          </button>

          <button type="button" @click="setAppStatus('gone')" class="btn btn-wabident-status gone status-check"
            :class="{ unmarked: !(app_status == 'gone') }">
            Se fue
          </button>

          <button type="button" @click="setAppStatus('cancel')" class="btn btn-wabident-status cancelled status-check"
            :class="{ unmarked: app_status != 'cancel' }">
            Cancelada
          </button>

          <button v-if="clinic_type == 'dental'" type="button" @click="setAppStatus('absent')"
            class="btn btn-wabident-status absent status-check" :class="{ unmarked: app_status != 'absent' }">
            No Acude/No Avisa
          </button>
        </div>
      </div>
      <!-- END Buttons -->

      <!-- Create Appointment -->
      <div class="form-group row">
        <div class="col text-center">
          <!-- DELETE -->
          <button :disabled="is_loading || agenda_restricted" @click="onDelete" v-show="is_edit && !treatments_only"
            class="btn btn-wabident-delete float-left" style="width: 53.6px; height: 53.6px"></button>
          <!-- SAVE / CREATE-->
          <button :disabled="save_disabled" @click="submit" role="button" class="btn btn-primary btn-wabident"
            style="min-width: 316px">
            <span v-if="is_edit">Guardar cambios</span>
            <span v-else>Crear cita</span>
            <i style="margin-top: 5px" v-if="is_loading" class="fas fa-circle-notch fa-spin float-right"></i>
          </button>
          <!-- WHATSAPP REMINDER -->
          <a class="whatsapp float-right" @click="onReminderSent" target="_blank" :href="whatsapp_url" v-if="!is_note">
            <svg :style="ws_button_style" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 30.667 30.667"
              xml:space="preserve">
              <g>
                <path d="M30.667,14.939c0,8.25-6.74,14.938-15.056,14.938c-2.639,0-5.118-0.675-7.276-1.857L0,30.667l2.717-8.017
		c-1.37-2.25-2.159-4.892-2.159-7.712C0.559,6.688,7.297,0,15.613,0C23.928,0.002,30.667,6.689,30.667,14.939z M15.61,2.382
		c-6.979,0-12.656,5.634-12.656,12.56c0,2.748,0.896,5.292,2.411,7.362l-1.58,4.663l4.862-1.545c2,1.312,4.393,2.076,6.963,2.076
		c6.979,0,12.658-5.633,12.658-12.559C28.27,8.016,22.59,2.382,15.61,2.382z M23.214,18.38c-0.094-0.151-0.34-0.243-0.708-0.427
		c-0.367-0.184-2.184-1.069-2.521-1.189c-0.34-0.123-0.586-0.185-0.832,0.182c-0.243,0.367-0.951,1.191-1.168,1.437
		c-0.215,0.245-0.43,0.276-0.799,0.095c-0.369-0.186-1.559-0.57-2.969-1.817c-1.097-0.972-1.838-2.169-2.052-2.536
		c-0.217-0.366-0.022-0.564,0.161-0.746c0.165-0.165,0.369-0.428,0.554-0.643c0.185-0.213,0.246-0.364,0.369-0.609
		c0.121-0.245,0.06-0.458-0.031-0.643c-0.092-0.184-0.829-1.984-1.138-2.717c-0.307-0.732-0.614-0.611-0.83-0.611
		c-0.215,0-0.461-0.03-0.707-0.03S9.897,8.215,9.56,8.582s-1.291,1.252-1.291,3.054c0,1.804,1.321,3.543,1.506,3.787
		c0.186,0.243,2.554,4.062,6.305,5.528c3.753,1.465,3.753,0.976,4.429,0.914c0.678-0.062,2.184-0.885,2.49-1.739
		C23.307,19.268,23.307,18.533,23.214,18.38z" />
              </g>
            </svg>
          </a>
          <!-- PRINT TICKET (OPTIONAL) -->
          <a v-if="can_print_ticket" :href="print_ticket_url" target="_blank"
            class="btn btn-wabident-round float-right mx-3" style="margin-top:10px">
            <i class="fas fa-print"></i> Ticket
          </a>
        </div>
      </div>
      <!-- END Create Appointment -->
    </b-modal>
  </div>
</template>
<script>
import { BIconHandThumbsDown } from "bootstrap-vue";
import { mapActions } from "vuex";

export default {
  props: {
    locked: { default: false },
    clinics: { default: null },
    mode: { default: "daily" },
  },
  data() {
    return {
      lock_doctor: false,
      is_note: false,
      is_edit: false,
      is_first: false,
      add_new_treatment: false,
      product_category_id: null,
      appointment: null,
      app_status: "pending",
      selected_customer: 0,
      selected_box: 0,
      selected_date: new Date().toISODate(),
      initial_date: new Date().toISODate(),
      is_date_changed: false,
      selected_time_start: "09:00",
      selected_time_end: "09:30",
      is_insurance: false,
      is_urgent: false,
      is_revision: false,
      is_marked: false,
      reminder_sent: false,
      app_notes: "",
      app_public_notes: "",
      is_loading: false,
      selected_treatment_ids: [],
      selected_treatment: 0,
      customer_treatments: [],
      doctor_id: null,
      user_id: null,
      app_origin: null,
      changed_reason: null,
      documents: [],
      is_custom_color: false,
      current_appointments: [],
      colors: {
        hex: "#000000",
      },
      custom_checks: {},
      treatments_only: false,
      next_app_data: {},
      selected_product: null,
    };
  },
  watch: {
    selected_date(value) {
      this.is_date_changed = value !== this.initial_date;
    },
    selected_treatment(value) {
      this.addSelectedTreatment(value);
    },
  },
  methods: {
    addSelectedTreatment(value) {
      if (value) {
        if (this.selected_treatment_ids.indexOf(value) < 0) {
          this.selected_treatment_ids.push(value);
        }
        this.selected_treatment = 0;
        this.updateEndTimeSlot();
        this.$forceUpdate();
      }
    },
    onDocumentAdded(document) {
      this.documents.push(document);
    },
    onDocumentEdited(document) {
      this.documents = this.documents.filter((d) => {
        return d.id != document.id;
      });
      this.documents.push(document);
    },
    addDocument() {
      let app_id = this.appointment ? this.appointment.id : null;
      this.$refs.showdocument.showNew(
        this.selected_customer,
        app_id,
        null,
        this.doctor_id
      );
    },
    editDocument(document) {
      this.$refs.showdocument.showEdit(this.selected_customer, document);
    },
    updateEndTimeSlot() {
      if (this.is_edit) return;

      let components = this.selected_time_start.split(":");
      let hour = Number.parseInt(components[0]) || 0;
      let minute = Number.parseInt(components[1]) || 0;
      let duration = Math.max(30, this.treatment_duration);

      minute = minute + duration;

      do {
        if (minute >= 60) {
          minute -= 60;
          hour += 1;
        }
      } while (minute >= 60);

      let tslot = this.getNearestTimeSlot(hour, minute, "end", "weekly");
      this.selected_time_end = tslot;
    },
    onReminderSent() {
      this.reminder_sent = true;
    },
    showCustomerNew(customer) {
      (this.next_app_data = {}), (this.treatments_only = false);
      this.lock_doctor = false;
      this.is_edit = false;
      this.is_note = false;
      this.selected_box = this.clinic.boxes[0].id;
      this.selected_date = new Date().toISODate();
      this.initial_date = new Date().toISODate();
      this.is_date_changed = false;
      this.app_status = "pending";
      this.is_insurance = false;
      this.is_urgent = false;
      this.is_revision = false;
      this.is_marked = false;
      this.doctor_id = null;
      this.user_id = null;
      this.mod_user_id = null;
      this.app_origin = null;
      this.changed_reason = null;
      this.reminder_sent = false;
      this.is_custom_color = false;
      this.colors = { hex: "#000000" };
      this.is_first = false;
      this.add_new_treatment = false;
      this.product_category_id = null;
      this.custom_checks = {};
      this.documents = [];

      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);
      this.$refs.modal.show();
    },
    getNearestTimeSlot(hour, minute, field = "start", override_mode = null) {
      let mode = this.mode;
      if (override_mode) {
        mode = override_mode;
      }

      if (mode == "daily" || mode == "boxes" || mode == "doctors") {
        return pad(hour, 2) + ":" + pad(minute, 2);
      }

      let tslot = pad(hour, 2) + ":" + pad(minute, 2);
      var candidate = tslot;

      let morning_timeslots = this.day_slots.morning[field];
      let afternoon_timeslots = this.day_slots.afternoon[field];

      for (let i = 0; i < morning_timeslots.length; i++) {
        candidate = morning_timeslots[i];
        if (candidate >= tslot) {
          if (field == "start" && i > 0) {
            return morning_timeslots[i - 1];
          }
          return candidate;
        }
      }

      for (let i = 0; i < afternoon_timeslots.length; i++) {
        candidate = afternoon_timeslots[i];
        if (candidate >= tslot) {
          if (field == "start" && i > 0) {
            return afternoon_timeslots[i - 1];
          }
          return candidate;
        }
      }

      return candidate;
    },
    show(date, timeslot, box, doctor_id) {
      (this.next_app_data = {}), (this.treatments_only = false);
      this.is_edit = false;
      this.selected_box = box ? box.id || 0 : 0;
      this.selected_date = date.toISODate();
      this.initial_date = this.selected_date;
      this.is_date_changed = false;
      this.selected_treatment_ids = [];
      this.selected_treatment = 0;
      this.appointment = null;
      this.app_status = "pending";
      this.selected_customer = null;
      this.doctor_id = doctor_id;

      if (this.doctor_id && this.is_core) {
        this.lock_doctor = true;
      } else {
        this.lock_doctor = false;
      }

      this.user_id = null;
      this.mod_user_id = null;
      this.reminder_sent = false;
      this.is_custom_color = false;
      this.colors = { hex: "#000000" };
      this.app_origin = null;
      this.changed_reason = null;
      this.is_first = false;
      this.add_new_treatment = false;
      this.product_category_id = null;
      this.custom_checks = {};
      this.documents = [];
      this.selected_product = null;

      let hour = Number(timeslot.hour);
      let minute = Number(timeslot.minute);
      this.selected_time_start = this.getNearestTimeSlot(hour, minute);

      minute = minute + 30;
      if (minute >= 60) {
        minute = minute - 60;
        hour += 1;
      }
      this.selected_time_end = this.getNearestTimeSlot(hour, minute, "end");

      this.is_insurance =
        this.is_urgent =
        this.is_revision =
        this.is_marked =
        false;

      this.app_notes = "";
      this.app_public_notes = "";

      this.is_note = !(this.selected_box || this.doctor_id);
      this.$refs.modal.show();
    },
    showEdit(appointment, treatments_only = false) {
      this.next_app_data = appointment.next_app_data || {};
      if (!WabiDent.isObject(this.next_app_data)) {
        this.next_app_data = {};
      }

      this.treatments_only = treatments_only;
      this.is_edit = true;
      this.is_note = appointment.customer_id === null;
      this.lock_doctor = false;

      if (this.is_note) {
        this.customerDeselected();
      }

      this.appointment = appointment;
      this.selected_box = appointment.box_id || 0;

      let date_from = moment(appointment.date_from).toDate();
      let date_to = moment(appointment.date_to).toDate();

      this.selected_date = date_from.toISODate();
      this.initial_date = date_from.toISODate();
      this.is_date_changed = false;

      this.selected_time_start =
        pad(date_from.getHours(), 2) + ":" + pad(date_from.getMinutes(), 2);

      this.selected_time_end =
        pad(date_to.getHours(), 2) + ":" + pad(date_to.getMinutes(), 2);

      this.app_notes = appointment.notes;
      this.app_public_notes = appointment.public_notes;

      this.is_insurance = appointment.is_insurance;
      this.is_revision = appointment.is_revision;
      this.is_urgent = appointment.is_urgent;
      this.is_marked = appointment.is_marked;
      this.app_status = appointment.status || "pending";
      this.doctor_id = appointment.doctor_id;
      this.user_id = appointment.user_id;
      this.mod_user_id = appointment.mod_user_id;
      this.app_origin = appointment.app_origin;
      this.changed_reason = appointment.changed_reason;
      this.is_first = appointment.is_first;
      this.add_new_treatment = false;
      this.product_category_id = appointment.product_category_id;
      this.custom_checks = appointment.custom_checks;
      this.documents = appointment.documents;
      this.selected_product = null;

      if (!WabiDent.isObject(this.custom_checks)) {
        this.custom_checks = {};
      }

      this.is_custom_color = !(
        appointment.color == null ||
        appointment.color == "#000000" ||
        appointment.color == "null"
      );

      if (this.is_custom_color) {
        this.colors = { hex: appointment.color };
      } else {
        this.colors = { hex: "#000000" };
      }

      this.reminder_sent = appointment.reminder_sent || false;
      setTimeout(() => {
        this.$refs.search.select(appointment.customer);
      }, 100);

      this.$refs.modal.show();
    },
    customerSelected(customer) {
      if (customer) {
        this.selected_customer = customer;
        this.selected_treatment_ids = [];
        this.selected_treatment = 0;
        this.customer_treatments = {};
        this.getCustomerTreatments(customer);
      }
    },
    onNewCustomer() {
      this.$refs.customerNew.show();
    },
    onCustomerCreated(customer) {
      setTimeout(() => {
        this.$refs.search.select(customer);
      }, 100);
    },
    getCustomerTreatments(customer, new_treatment_id = null) {

      this.customer_treatments = {};
      axios
        .get(`/customer/${customer.id}/curr_treatments`)
        .then((response) => {
          let ret = {};
          response.data.forEach((treatment) => {
            ret[treatment.id] = treatment;
          });

          this.customer_treatments = ret;

          // Repopulate the available treatments for the selector
          if (this.appointment && this.appointment.treatments) {
            this.appointment.treatments.forEach((x) => {
              if (!this.customer_treatments[x.id]) {
                this.customer_treatments[x.id] = x;
              }
            });
          }

          // If we are editing an existing appointment, prefill the selected treatments
          // from the appointment data
          if (this.is_edit && this.appointment) {
            this.selected_treatment_ids = this.appointment.treatments.map(
              (t) => t.id
            );
          }

          // If we just added a new treatment from the agenda. Add it manually (called from quickAddTreatment)
          if (new_treatment_id) {
            this.addSelectedTreatment(new_treatment_id);
          }
        })
        .catch((error) => {
          console.log("[ERR] getCustomerTreatments", error);
        });
    },
    customerDeselected() {
      this.selected_customer = null;
      this.selected_treatment_ids = [];
      this.selected_treatment = 0;
      this.customer_treatments = {};
      this.app_status = "pending;";
      this.selected_product = null;
    },
    removeTreatment(id) {
      if (this.agenda_restricted) {
        return;
      }

      this.selected_treatment_ids = this.selected_treatment_ids.filter(
        (treatment) => {
          return id != treatment;
        }
      );

      this.updateEndTimeSlot();
    },
    setAppStatus(status) {
      if (status == this.app_status) {
        this.app_status = "pending";
      } else {
        this.app_status = status;
      }
    },
    submit() {
      let message = null;
      let overdone_treatments = this.selected_customer_treatments.filter(
        (t) => {
          return t.max_sessions > 0 && t.sessions_done >= t.max_sessions;
        }
      );

      if (overdone_treatments.length > 0) {
        message =
          "Los siguientes tratamientos han superado el límite de sesiones:<br>" +
          overdone_treatments
            .map((t) => {
              return t.full_name + ` (${t.max_sessions})`;
            })
            .join("<br>");
      }

      if (message) {
        this.errorwindow.show("Aviso", message, "Aceptar", "Cancelar", () => {
          this.doSubmit();
        });
      } else {
        this.doSubmit();
      }
    },
    doSubmit() {
      if (this.is_loading) {
        return;
      }

      if (!this.validate()) {
        return;
      }

      if (this.is_edit) {
        this.modifyAppointment();
      } else {
        this.createAppointment();
      }
    },
    validate() {
      let errors = [];

      if (this.can_edit_user && !this.is_note) {
        if (!this.user_id) {
          errors.push("Debes indicar quien tomó la cita");
        }

        if (this.is_edit && this.date_changed && !this.mod_user_id) {
          errors.push(
            "Ha cambiado la fecha de la cita. Debes indicar quien modificó la cita"
          );
        }
      }

      if (errors.length > 0) {
        this.errorwindow.show("Error", "<p>" + errors.join("<p>") + "</p>");
        return false;
      }

      return true;
    },
    getRequestParameters() {
      let from_moment = moment.utc(
        this.selected_date + " " + this.selected_time_start
      );

      let to_moment = moment.utc(
        this.selected_date + " " + this.selected_time_end
      );

      return {
        customer_id: this.selected_customer ? this.selected_customer.id : 0,
        treatment_ids: this.selected_treatment_ids
          ? this.selected_treatment_ids
          : [],
        box_id: this.selected_box || 0,
        date_from: from_moment.toISOString(),
        date_to: to_moment.toISOString(),
        is_insurance: this.is_insurance,
        is_revision: this.is_revision,
        is_urgent: this.is_urgent,
        is_marked: this.is_marked,
        notes: this.app_notes,
        public_notes: this.app_public_notes,
        status: this.app_status,
        doctor_id: this.doctor_id,
        reminder_sent: this.reminder_sent,
        color: this.is_custom_color ? this.colors.hex : null,
        changed_reason: this.changed_reason,
        app_origin: this.app_origin,
        user_id: this.user_id,
        mod_user_id: this.mod_user_id,
        is_first: this.is_first,
        product_category_id: this.product_category_id,
        custom_checks: this.custom_checks,
        documents: this.document_ids,
        next_app_data: this.next_app_data,
      };
    },
    createAppointment() {
      this.is_loading = true;
      axios
        .post(
          `/clinic/${this.clinic.id}/appointments`,
          this.getRequestParameters()
        )
        .then((response) => {
          if (response.data.error) {
            this.errorwindow.show("Error", response.data.error);
          } else {
            this.$emit("submit");
            this.msgwindow.addMessage("success", "Cita creada con éxito");
            this.$refs.modal.hide();
          }
          this.is_loading = false;
        })
        .catch((error) => {
          console.log("[ERR] createAppoinment:", error.response.data);
          this.is_loading = false;
        });
    },
    modifyAppointment() {
      if (this.appointment) {
        this.is_loading = true;
        axios
          .post(
            `/clinic/${this.clinic.id}/appointments/${this.appointment.id}`,
            this.getRequestParameters()
          )
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
            } else {
              this.$emit("submit");
              this.msgwindow.addMessage("success", "Cita modificada con éxito");
              this.$refs.modal.hide();
            }
            this.is_loading = false;
          })
          .catch((error) => {
            console.log("[ERR] modifyAppointment:", error.response.data);
            this.is_loading = false;
          });
      }
    },
    onDelete() {
      this.errorwindow.show(
        "Confirmación",
        "¿Desea borrar esta cita?",
        "Borrar",
        "Cancelar",
        this.onDeleteConfirm,
        null
      );
    },
    onDeleteConfirm() {
      if (this.is_edit && !this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/clinic/${this.clinic.id}/appointments/${this.appointment.id}/delete`,
            { _method: "delete" }
          )
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
            } else {
              this.$emit("submit");
              this.msgwindow.addMessage("success", "Cita borrada con éxito");
              this.$refs.modal.hide();
            }
            this.is_loading = false;
          })
          .catch((error) => {
            console.log("[ERR] deleteAppointment:", error.response.data);
            this.is_loading = false;
          });
      }
    },
    getTreatmentName(treatment, brief = false) {
      let status =
        {
          pending: "Pendiente",
          done: "Realizado",
          done_prior: "Rel. por otros",
        }[treatment.status] || "N/D";

      let ret = treatment.product ? treatment.full_name : treatment.notes;
      if (brief) {
        return ret;
      }

      ret += " - " + moment(treatment.created_at).format("DD/MM/YY");
      ret += " - " + status;
      return ret;
    },
    getWhatsappMessage(date) {
      if (!this.clinic) return "";

      if (this.clinic.config && this.clinic.config.whatsapp_msg) {
        let msg = this.clinic.config.whatsapp_msg
          .replace(
            "@nombre@",
            this.selected_customer ? this.selected_customer.name : ""
          )
          .replace("@clinica@", this.clinic.name)
          .replace("@fecha@", date)
          .replace("@hora@", this.selected_time_start)
          .replace("@doctor@", this.doctor ? this.doctor.name : "");
        return msg;
      }

      return `Le recordamos que tiene cita en *${this.clinic.name}* el *${date} a las ${this.selected_time_start}*`;
    },
    showHistory() {
      this.$refs.apphistory.show();
    },
    addProductToAppointment() {
      if (this.is_loading) {
        return;
      }

      const product_type =
        this.selected_product.type == "product" ? "Producto" : "Tratamiento";

      this.errorwindow.show(
        `Añadir ${product_type} al plan del Paciente?`,
        "Se añadirá al último plan creado del paciente o se creara uno nuevo",
        "Crear",
        "Cancelar",
        () => {
          this.doAddProductToAppointment();
        }
      );
    },
    doAddProductToAppointment() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;
      const doctor_id = this.doctor_id ? this.doctor_id : this.clinic.doctor_id;
      const post_data = {
        product_id: this.selected_product.id,
        clinic_id: this.clinic.id,
        doctor_id: doctor_id,
      };

      let success_data = null;

      axios
        .post(
          `/customer/${this.selected_customer.id}/quick_add_treatment`,
          post_data
        )
        .then((response) => {
          success_data = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.is_loading = false;
          if (success_data && success_data.treatment_id) {
            this.getCustomerTreatments(
              this.selected_customer,
              success_data.treatment_id
            );
          }
        });
    },
  },
  computed: {
    doctor_locked() {
      return this.lock_doctor && !this.user_capabilities.admin;
    },
    agenda_restricted() {
      return this.user_capabilities.agenda_restricted;
    },
    document_ids() {
      if (!this.documents) {
        return [];
      }

      return this.documents.map((d) => {
        return d.id;
      });
    },
    enable_custom_checks() {
      return (
        this.clinic &&
        this.clinic.config.agenda_appointment_enable_custom_checks
      );
    },
    custom_check_list() {
      if (!this.clinic) return {};

      return this.clinic.config.agenda_appointment_custom_checks;
    },
    treatment_duration() {
      let ret = 0;
      this.selected_customer_treatments.forEach((treatment) => {
        ret += treatment.product.default_duration;
      });
      return ret;
    },
    categories() {
      if (!this.clinic) return [];
      return this.clinic.product_categories.filter((cat) => {
        return !cat.parent_id;
      });
    },
    active_users() {
      if (this.clinic && this.clinic.users) {
        return this.clinic.users.filter((x) => {
          return x.is_active != 0;
        });
      }
      return [];
    },
    api_enabled() {
      if (this.clinic && this.clinic.config) {
        return this.clinic.config.enable_api;
      }
      return false;
    },
    public_notes_enabled() {
      if (!this.api_enabled) return false;
      if (!this.selected_customer) return false;

      return this.selected_customer.enable_passwd;
    },
    can_edit_user() {
      if (this.clinic && this.clinic.config) {
        return this.clinic.config.agenda_app_edit_user && !this.is_note;
      }
      return false;
    },
    arrival_time() {
      if (!this.appointment || !this.appointment.arrival_time) return null;
      return moment(this.appointment.arrival_time).format("DD/MM/YYYY H:mm");
    },
    attended_time() {
      if (!this.appointment || !this.appointment.attended_time) return null;
      return moment(this.appointment.attended_time).format("DD/MM/YYYY H:mm");
    },
    leaving_time() {
      if (!this.appointment || !this.appointment.leaving_time) return null;
      return moment(this.appointment.leaving_time).format("DD/MM/YYYY H:mm");
    },
    gone_time() {
      if (!this.appointment || !this.appointment.gone_time) return null;
      return moment(this.appointment.gone_time).format("DD/MM/YYYY H:mm");
    },
    created_at() {
      if (!this.appointment) return "";
      return moment(this.appointment.created_at).format("DD/MM/YYYY H:mm");
    },
    updated_at() {
      if (!this.appointment) return "";
      return moment(this.appointment.updated_at).format("DD/MM/YYYY H:mm");
    },
    user_name() {
      if (!this.appointment || !this.appointment.user_id) return "";

      const user = this.clinic.users.filter((u) => {
        return u.id == this.appointment.user_id;
      })[0];

      return user ? user.name : "";
    },
    ws_button_style() {
      if (!this.reminder_sent) {
        return {
          color: "var(--theme-color) !important",
          fill: "var(--theme-color) !important",
        };
      }

      return {
        color: "var(--theme-color-attended) !important",
        fill: "var(--theme-color-attended) !important",
      };
    },
    customer_edit_link() {
      if (!this.selected_customer) return null;
      return `/customer/${this.selected_customer.id}/edit`;
    },
    save_disabled() {
      return (
        this.is_loading ||
        this.is_vacation ||
        (!this.is_note && this.selected_customer == null) ||
        (this.is_aesthetic && !this.is_core && this.doctor_id == null)
      );
    },
    dayindex() {
      let d = moment(this.selected_date).toDate().getDay();
      if (d == 0) return 6;
      return d - 1;
    },
    is_dental() {
      return !this.is_aesthetic;
    },
    is_aesthetic() {
      if (!this.clinic) return false;
      return this.clinic.type == "aesthetic";
    },
    is_vacation() {
      if (!this.clinic) return true;

      let slots = this.day_slots;
      if (!slots.checked) return true;

      let found = this.clinic.schedule.vacations.find((vacation) => {
        return vacation == this.date.toISODate();
      });

      if (found) return true;

      return false;
    },
    date() {
      return moment.utc(this.selected_date).toDate();
    },
    day_slots() {
      if (!this.clinic) return [];
      return this.clinic.schedule.daily_timeslots[this.dayindex];
    },
    doctor() {
      if (!this.doctor_id) return null;

      let filtered = this.doctors.filter((d) => {
        return this.doctor_id == d.doctor.id;
      });

      return filtered[0] || null;
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((x) => {
        return x.is_active != 0;
      });
    },
    can_print_ticket() {
      return this.is_edit && !this.is_note && this.clinic && Boolean(this.clinic.config.appointments_ticket_template);
    },
    print_ticket_url() {
      if (!this.can_print_ticket) {
        return '';
      }

      return `/clinic/${this.clinic.id}/appointments/${this.appointment.id}/ticket`;
    },
    show_whatsapp() {
      return (
        this.is_core ||
        (this.is_edit &&
          (this.app_status == "pending" || this.app_status == "confirmed") &&
          this.selected_customer != null)
      );
    },
    whatsapp_url() {
      if (!this.selected_customer || !this.selected_customer.phone) return "";

      let from_moment = moment.utc(
        this.selected_date + " " + this.selected_time_start
      );
      let date = from_moment.format("LL");

      let number = String(this.selected_customer.phone)
        .replace(" ", "")
        .replace("-", "")
        .replace("+", "")
        .replace("(", "")
        .replace(")", "");

      if (!this.selected_customer.phone.includes("+")) {
        number = "34" + number;
      }

      let text = encodeURIComponent(this.getWhatsappMessage(date));
      if (this.clinic.config.use_wa_app) {
        return `whatsapp://send?phone=${number}&text=${text}`;
      }

      return `https://wa.me/${number}/?text=${text}`;
    },
    dialog_title() {
      if (this.is_note) {
        return this.is_edit ? "Editar Nota" : "Nueva Nota";
      } else {
        return this.is_edit ? "Editar Cita" : "Nueva Cita";
      }
    },
    selected_customer_treatments() {
      if (!this.customer_treatments) return [];
      return Object.values(this.customer_treatments).filter((treatment) => {
        return this.selected_treatment_ids.indexOf(treatment.id) >= 0;
      });
    },
    customer_has_treatments() {
      if (!this.selected_customer || !this.customer_treatments) return false;

      return Object.values(this.customer_treatments).length > 0;
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    can_add_new_treatment() {
      return (
        !this.is_first &&
        !this.is_note &&
        this.selected_customer &&
        this.clinic &&
        this.clinic.config &&
        this.clinic.config.agenda_add_new_treatments
      );
    },
    ...mapGetters([
      "clinic",
      "msgwindow",
      "errorwindow",
      "is_core",
      "user_capabilities",
    ]),
  },
};
</script>
